import { z } from 'zod';

import { env } from '@/env';
import type { MessageKeyWithParams } from '@/modules/forms';
import type { MessageKey } from '@/modules/localizations/translations/types';
import type { EntityWithPermissions } from '@/types';

import { Fields, SecretType } from '../constants';
import type { Base64File } from '../types';
import { hasExecutableFileExtension, isValidFileSize } from '../utilities';

export const basicSecretFormSchema = z.object({
    [Fields.TYPE]: z.nativeEnum(SecretType),
    [Fields.NAME]: z.string().min(1, { message: 'form.error.required' satisfies MessageKey }),
    [Fields.NOTE]: z.string().optional(),
    [Fields.TAGS]: z.array(z.string()).optional(),
    [Fields.GROUPS]: z.array(z.custom<EntityWithPermissions>()).optional(),
    [Fields.WHITELIST_USERS]: z.array(z.custom<EntityWithPermissions>()).optional(),
    [Fields.VAULT_ID]: z.string().nullish(),
    [Fields.FILE]: z
        .custom<Base64File>()
        .refine(val => !hasExecutableFileExtension(val?.name ?? ''), {
            message: 'secret.file.executableNotAllowed' satisfies MessageKey,
        })
        .refine(val => isValidFileSize(val), {
            message: `form.error.fileSize|{"maxSize":"${env.VITE_SAAS ? '30KiB' : '512KiB'}"}` satisfies MessageKeyWithParams,
        })
        .nullish(),
});
